import { createSlice } from "@reduxjs/toolkit";

const storedData = JSON.parse(localStorage.getItem("auth"));
const hasStoredData =
	storedData && storedData.token && new Date(storedData.expirationDate) > new Date();

const initialState = {
	token: hasStoredData ? storedData.token : null,
	user: hasStoredData ? storedData.user : null,
};

const authSlice = createSlice({
	name: "auth",
	initialState,
	reducers: {
		setToken(state, action) {
			state.token = action.payload;
		},
		setUser(state, action) {
			state.user = action.payload;
		},
	},
});

export const authActions = authSlice.actions;
export default authSlice;
